/* prettier-ignore */
export default ({
  getIsDialogOpen: state => state.fieldModelReferenceDialog.dialogOpen,
  getFieldModelDiff: state => state.fieldModelReferenceDialog.diff,
  getIsAvailable: state => state.fieldModelReferenceDialog.isAvailable,
  getData: state => state.fieldModelReferenceDialog.data,
});
